import React, { useState, useEffect } from 'react';
import CalcShell from '../CalcShell';
import { CNetActions, CNetResult, G } from './_cnet';

// Common weight/mass units → grams
const UNITS = {
  'milligram (mg)': 0.001,
  'gram (g)': 1,
  'kilogram (kg)': 1000,
  'metric ton (t)': 1e6,
  'ounce (oz)': 28.3495,
  'pound (lb)': 453.592,
  'stone (st)': 6350.29,
  'short ton (US)': 907185,
  'long ton (UK)': 1016047,
  'grain (gr)': 0.06479891,
  'carat (ct)': 0.2,
  'slug': 14593.9,
  'atomic mass unit (u)': 1.66054e-24,
};

export default function WeightCalc() {
  const [value, setValue] = useState(70);
  const [from, setFrom] = useState('kilogram (kg)');
  const [res, setRes] = useState(null);
  const calc = () => setRes({ grams: Number(value) * UNITS[from] });
  useEffect(() => { calc(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [value, from]);

  return (
    <CalcShell look="cnet" showActions={false} title="Weight Calculator" subtitle="Convert any weight or mass value into every commonly used unit — metric, imperial, scientific and more.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="cnet-panel">
          <div className="cnet-row-2col"><div className="cnet-label">Value</div>
            <input data-testid="weight-value" className="cnet-input" type="number" step="any" value={value} onChange={e => setValue(e.target.value)} />
          </div>
          <div className="cnet-row-2col"><div className="cnet-label">From</div>
            <select data-testid="weight-from" className="cnet-select" value={from} onChange={e => setFrom(e.target.value)}>{Object.keys(UNITS).map(u => <option key={u}>{u}</option>)}</select>
          </div>
          <CNetActions onCalc={calc} onClear={() => setRes(null)} testId="weight" />
        </div>
        <div>
          {res && (
            <CNetResult title="Conversion Result">
              <table className="data-table" data-testid="weight-result">
                <thead><tr><th>Unit</th><th className="text-right">Value</th></tr></thead>
                <tbody>{Object.entries(UNITS).map(([u, k]) => (
                  <tr key={u} className={u === from ? 'bg-emerald-50' : ''}>
                    <td>{u}</td>
                    <td className="text-right font-mono">{G(res.grams / k, 6)}</td>
                  </tr>
                ))}</tbody>
              </table>
            </CNetResult>
          )}
        </div>
      </div>
    </CalcShell>
  );
}
